var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgProduct = function SvgProduct(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.438.188h15.125v15.125H.436V.186Zm1.375 1.375v5.5h5.5v-5.5h-5.5Zm6.875 0v5.5h5.5v-5.5h-5.5ZM1.811 8.438v5.5h5.5v-5.5h-5.5Zm6.875 0v5.5h5.5v-5.5h-5.5Z",
    fill: "currentColor"
  })));
};

export default SvgProduct;